import {createSelector, Selector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {WARNING_SLICE} from './constants';
import {IWarningModuleState} from './types';

const rootSelector: Selector<TAppState, IWarningModuleState> = (state: TAppState) => state[WARNING_SLICE];

export const selectWarningVisibilitySelector = (entityName: string) => createSelector(
    rootSelector,
    (warningState: IWarningModuleState) => warningState[entityName]?.visible,
);
